// Service Area Configuration
// Define your delivery zone boundaries

export interface ServiceArea {
  center: {
    lat: number;
    lng: number;
  };
  radius: number; // in kilometers
  name: string;
}

// Configure your service area here
// Bhadrachalam, Telangana 507111
export const SERVICE_AREA: ServiceArea = {
  center: {
    lat: 17.6689,  // Bhadrachalam center
    lng: 80.8936
  },
  radius: 5, // 5 km delivery radius
  name: 'Bhadrachalam' // Your city name
};

// Calculate distance between two points using Haversine formula
export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const toRad = (value: number): number => {
  return (value * Math.PI) / 180;
};

// Check if a location is within service area
export const isWithinServiceArea = (lat: number, lng: number): boolean => {
  const distance = calculateDistance(
    SERVICE_AREA.center.lat,
    SERVICE_AREA.center.lng,
    lat,
    lng
  );
  return distance <= SERVICE_AREA.radius;
};

// Get distance from service center
export const getDistanceFromCenter = (lat: number, lng: number): number => {
  return calculateDistance(
    SERVICE_AREA.center.lat,
    SERVICE_AREA.center.lng,
    lat,
    lng
  );
};

// Calculate delivery charge based on distance
// Within 2.5km: ₹50
// 2.5km - 3.5km: ₹70
// Above 3.5km: ₹90
export const calculateDeliveryCharge = (lat: number, lng: number): number => {
  const distance = getDistanceFromCenter(lat, lng);
  
  if (distance <= 2.5) {
    return 50;
  } else if (distance <= 3.5) {
    return 70;
  } else {
    return 90;
  }
};
